import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const DuplicateDetectionAlert = ({ 
  duplicates = [],
  onViewDuplicate = () => {},
  onIgnore = () => {},
  onMerge = () => {},
  className = '' 
}) => {
  if (duplicates?.length === 0) return null;

  return (
    <div className={`bg-warning/10 border border-warning/20 rounded-lg p-4 ${className}`}>
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0">
          <Icon name="AlertTriangle" size={20} className="text-warning" />
        </div>
        
        <div className="flex-1 min-w-0">
          <h4 className="text-sm font-medium text-text-primary mb-2">
            Potential Duplicate Contacts Found
          </h4>
          
          <p className="text-sm text-text-secondary mb-3">
            We found {duplicates?.length} contact{duplicates?.length > 1 ? 's' : ''} that might be similar to the one you're creating:
          </p>

          {/* Duplicate Contacts List */}
          <div className="space-y-2 mb-4">
            {duplicates?.slice(0, 3)?.map((duplicate, index) => (
              <div key={duplicate?.id || index} className="flex items-center space-x-3 p-2 bg-surface rounded-md border border-border">
                <div className="w-8 h-8 rounded-full bg-muted overflow-hidden flex-shrink-0">
                  {duplicate?.avatar ? (
                    <Image
                      src={duplicate?.avatar}
                      alt={duplicate?.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <Icon name="User" size={16} className="text-text-secondary" />
                    </div>
                  )}
                </div>
                
                <div className="flex-1 min-w-0">
                  <div className="text-sm font-medium text-text-primary truncate">
                    {duplicate?.name}
                  </div>
                  <div className="text-xs text-text-secondary truncate">
                    {duplicate?.email || duplicate?.phone || 'No contact info'}
                  </div>
                </div>

                <Button
                  variant="ghost"
                  size="xs"
                  onClick={() => onViewDuplicate(duplicate)}
                  iconName="Eye"
                  iconPosition="left"
                >
                  View
                </Button>
              </div>
            ))}
            
            {duplicates?.length > 3 && (
              <p className="text-xs text-text-secondary text-center">
                +{duplicates?.length - 3} more potential duplicate{duplicates?.length - 3 > 1 ? 's' : ''}
              </p>
            )}
          </div>

          {/* Action Buttons */}
          <div className="flex flex-wrap gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onIgnore}
              iconName="X"
              iconPosition="left"
            >
              Ignore & Continue
            </Button>
            
            <Button
              variant="default"
              size="sm"
              onClick={() => onMerge(duplicates?.[0])}
              iconName="GitMerge"
              iconPosition="left"
            >
              Merge with First Match
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DuplicateDetectionAlert;